export function resolveLocale (savedLocale, browserLanguage) {
  if (['en-US', 'zh-CN'].includes(savedLocale)) return savedLocale
  return browserLanguage.slice(0, 2) === 'zh' && browserLanguage !== 'zh-TW' ? 'zh-CN' : 'en-US'
}
